"use client";

// import { Flex, Text } from "@chakra-ui/react";
import { Checkbox } from "./ui/checkbox";

export const CheckboxComp = ({ label, onChange, value }) => {
  return (
    <Checkbox
      onCheckedChange={(v) => onChange(v.checked)}
      checked={value || false}
    >
      {label || ""}
    </Checkbox>
  );
};
